<label class="filter-label" [attr.for]="inputId()">{{ label() }}</label>

<div class="combobox-field" (mousedown)="onFieldMouseDown()">
  <input
    #comboboxInput
    type="text"
    role="combobox"
    autocomplete="off"
    spellcheck="false"
    class="combobox-input"
    [id]="inputId()"
    [attr.data-testid]="testId()"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="open() ? listboxId() : null"
    aria-autocomplete="list"
    [attr.aria-activedescendant]="activeOptionId()"
    [attr.aria-describedby]="statusId()"
    [attr.placeholder]="placeholder()"
    [disabled]="disabled()"
    [value]="displayText()"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />

  <!-- Suppressed while disabled (GH-34 §1 D-8): the value still RENDERS — an inherited selection
       is declared at the control — but clearing it is an operation, and the treatment is that this
       view offers none. A reachable button beside an unreachable field is the inconsistency the
       whole change exists to remove; Reset still clears it from anywhere (D-1). -->
  @if (hasSelection() && !disabled()) {
    <button
      type="button"
      class="combobox-clear"
      [attr.data-testid]="testId() + '-clear'"
      [attr.aria-label]="'Clear ' + label() + ' filter'"
      (mousedown)="$event.preventDefault(); $event.stopPropagation()"
      (click)="clear()"
    >
      <fa-icon [icon]="clearIcon" aria-hidden="true" />
    </button>
  }

  <span class="combobox-chevron" aria-hidden="true">
    <fa-icon [icon]="chevronIcon" />
  </span>
</div>

@if (open()) {
  <ul class="combobox-listbox" [id]="listboxId()" role="listbox" [attr.aria-label]="label()">
    @for (entry of visibleOptions(); track entry.unspecified ? '' : 'v:' + entry.value; let index = $index) {
      <li
        role="option"
        class="combobox-option"
        [class.is-unspecified]="entry.unspecified"
        [attr.aria-label]="entry.unspecified ? unspecifiedDescription() : null"
        [id]="optionId(index)"
        [class.active]="activeOptionId() === optionId(index)"
        [attr.aria-selected]="isSelected(entry)"
        (mousedown)="onOptionMouseDown($event, entry)"
      >
        {{ entry.text }}
      </li>
    } @empty {
      <!-- Announced as an option so the listbox is never empty for a screen
           reader, but aria-disabled so it can never be committed. -->
      <li role="option" class="combobox-option is-empty" aria-disabled="true" [attr.aria-selected]="false">
        No matches
      </li>
    }
  </ul>
}

<!--
  Always rendered, empty in the success state: the control's height must not
  change when options arrive (SC-005, "no visible layout shift").
-->
<p
  class="filter-status"
  [id]="statusId()"
  [attr.data-testid]="testId() + '-status'"
  role="status"
>{{ statusMessage() }}</p>
